export interface ChatMessage {
  from: 'docente' | 'noi'
  text: string
  time: string
}

export interface Testimonial {
  name: string
  role: string
  initials: string
  messages: ChatMessage[]
}

export const testimonials: Testimonial[] = [
  {
    name: 'Chiara M.',
    role: 'Docente, 3ª Primaria',
    initials: 'CM',
    messages: [
      {
        from: 'docente',
        text: 'Finalmente ho un percorso strutturato. Prima passavo le domeniche a raccogliere idee da internet.',
        time: '09:14',
      },
      {
        from: 'noi',
        text: 'Grazie Chiara! Come stanno rispondendo i bambini?',
        time: '09:21',
      },
      {
        from: 'docente',
        text: 'Sono molto più coinvolti: le attività seguono una progressione vera, si vede che una cosa porta all’altra.',
        time: '09:23',
      },
    ],
  },
  {
    name: 'Luca B.',
    role: 'Docente generalista, Primaria',
    initials: 'LB',
    messages: [
      {
        from: 'docente',
        text: 'Non ho una formazione specifica in geografia ed ero un po’ in ansia.',
        time: '17:02',
      },
      {
        from: 'docente',
        text: 'Le schede sono chiare e guidate: arrivo in classe sapendo esattamente cosa dire e cosa far fare.',
        time: '17:03',
      },
      { from: 'noi', text: 'È esattamente lo scopo del Kit di Sopravvivenza 🙂', time: '17:10' },
    ],
  },
  {
    name: 'Sara D.',
    role: 'Docente, 2ª Media',
    initials: 'SD',
    messages: [
      {
        from: 'docente',
        text: 'La differenza è che questo materiale è "da fare", non solo teoria da leggere.',
        time: '20:41',
      },
      {
        from: 'noi',
        text: 'Hai provato anche i volumi degli anni precedenti?',
        time: '20:47',
      },
      {
        from: 'docente',
        text: 'Sì, e la progressione tra un anno e l’altro si vede davvero. Stampo, seguo la guida e funziona.',
        time: '20:49',
      },
    ],
  },
]

export const socialStats: [string, string][] = [
  ['500+', 'Clienti'],
  ['4.9', 'Valutazione'],
  ['100%', 'Soddisfazione'],
]
